export default __webpack_public_path__ + "static/media/lampshade.5880c44a.svg";